<script setup lang="ts">
import { HugeIcon } from '@teachino/shared-design-system';
import { readFragment, type FragmentOf } from '@teachino/shared-infrastructure';
import { $t, type Translation } from '@teachino/shared-i18n';
import { computed } from 'vue';
import { tenantLicenseFragment } from './tenant-license.fragment';

const FEATURE_ICON_SIZE = 16;

const props = defineProps<{
  license: FragmentOf<typeof tenantLicenseFragment>;
}>();

const license = computed(() =>
  readFragment(tenantLicenseFragment, props.license),
);

const dpaHighlights = computed<string[]>(() => [
  $t('upgrade.license_page.dpa_signed'),
  $t('upgrade.license_page.student_data_can_be_managed'),
]);
</script>

<template>
  <article class="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
    <div class="mb-4 flex flex-wrap items-center gap-2">
      <span
        class="bg-success-50 text-success-700 rounded-md px-2 py-1 text-sm font-semibold"
      >
        {{ $t(`upgrade.plan.${license.plan.key}` as Translation) }}
      </span>
      <span class="text-sm text-slate-600">
        {{ license.tenant.name }}
      </span>
    </div>

    <ul class="space-y-2 text-sm text-slate-700">
      <li
        v-for="highlight in dpaHighlights"
        :key="highlight"
        class="flex items-start gap-2"
      >
        <span class="text-primary-600 mt-0.5 shrink-0">
          <HugeIcon icon="checkmark_circle" :size="FEATURE_ICON_SIZE" />
        </span>
        <span>{{ highlight }}</span>
      </li>
    </ul>
  </article>
</template>
